import { EmptyState } from './EmptyState';
import { TFunction } from 'i18next';
import { Card } from './Card';
import { MapPinIcon } from '@heroicons/react/24/solid';

type MyAccountEmptyStateProps = {
    t: TFunction;
    className?: string;
};
export const MyAccountEmptyState = ({
    t,
    className,
}: MyAccountEmptyStateProps) => {
    return (
        <Card
            className={className}
            contentClassName="!p-0 !py-0"
            title="SIMs Statistics"
            icon={<MapPinIcon className="w-6 h-6 text-primary opacity-45" />}
            content={
                <EmptyState
                    title={t(
                        'pages.dashboard.widgets.EmptyState.myAccount.title'
                    )}
                    description={t(
                        'pages.dashboard.widgets.EmptyState.myAccount.description'
                    )}
                />
            }
        />
    );
};
